/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
/**
 * WcIdentityApi - axios parameter creator
 * @export
 */
export const WcIdentityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Invoke tWAS OIDC interceptor for WC, and once WC authenticates with Blue ID and creates an LTPA token, redirect back to the CI referrer login servlet.
         * @param {string} storeId The store identifier.
         * @param {string} [responseFormat] The response format. If the request has an input body, that body must also use the format specified in \&quot;responseFormat\&quot;. Valid values include �json� and �xml� without the quotes. If the responseFormat isn�t specified, the �accept� HTTP header shall be used to determine the format of the response. If the �accept� HTTP header isn�t specified as well, the default response format shall be in json.
         * @param {string} [urlHeader] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdWcidentityGet: async (storeId: string, responseFormat?: string, urlHeader?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeStoreIdWcidentityGet', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/wcidentity`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (responseFormat !== undefined) {
                localVarQueryParameter['responseFormat'] = responseFormat;
            }

            if (urlHeader !== undefined) {
                localVarQueryParameter['urlHeader'] = urlHeader;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WcIdentityApi - functional programming interface
 * @export
 */
export const WcIdentityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WcIdentityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Invoke tWAS OIDC interceptor for WC, and once WC authenticates with Blue ID and creates an LTPA token, redirect back to the CI referrer login servlet.
         * @param {string} storeId The store identifier.
         * @param {string} [responseFormat] The response format. If the request has an input body, that body must also use the format specified in \&quot;responseFormat\&quot;. Valid values include �json� and �xml� without the quotes. If the responseFormat isn�t specified, the �accept� HTTP header shall be used to determine the format of the response. If the �accept� HTTP header isn�t specified as well, the default response format shall be in json.
         * @param {string} [urlHeader] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeStoreIdWcidentityGet(storeId: string, responseFormat?: string, urlHeader?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeStoreIdWcidentityGet(storeId, responseFormat, urlHeader, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WcIdentityApi - factory interface
 * @export
 */
export const WcIdentityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WcIdentityApiFp(configuration)
    return {
        /**
         * 
         * @summary Invoke tWAS OIDC interceptor for WC, and once WC authenticates with Blue ID and creates an LTPA token, redirect back to the CI referrer login servlet.
         * @param {string} storeId The store identifier.
         * @param {string} [responseFormat] The response format. If the request has an input body, that body must also use the format specified in \&quot;responseFormat\&quot;. Valid values include �json� and �xml� without the quotes. If the responseFormat isn�t specified, the �accept� HTTP header shall be used to determine the format of the response. If the �accept� HTTP header isn�t specified as well, the default response format shall be in json.
         * @param {string} [urlHeader] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdWcidentityGet(storeId: string, responseFormat?: string, urlHeader?: string, options?: any): AxiosPromise<void> {
            return localVarFp.storeStoreIdWcidentityGet(storeId, responseFormat, urlHeader, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WcIdentityApi - object-oriented interface
 * @export
 * @class WcIdentityApi
 * @extends {BaseAPI}
 */
export class WcIdentityApi extends BaseAPI {
    /**
     * 
     * @summary Invoke tWAS OIDC interceptor for WC, and once WC authenticates with Blue ID and creates an LTPA token, redirect back to the CI referrer login servlet.
     * @param {string} storeId The store identifier.
     * @param {string} [responseFormat] The response format. If the request has an input body, that body must also use the format specified in \&quot;responseFormat\&quot;. Valid values include �json� and �xml� without the quotes. If the responseFormat isn�t specified, the �accept� HTTP header shall be used to determine the format of the response. If the �accept� HTTP header isn�t specified as well, the default response format shall be in json.
     * @param {string} [urlHeader] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WcIdentityApi
     */
    public storeStoreIdWcidentityGet(storeId: string, responseFormat?: string, urlHeader?: string, options?: any) {
        return WcIdentityApiFp(this.configuration).storeStoreIdWcidentityGet(storeId, responseFormat, urlHeader, options).then((request) => request(this.axios, this.basePath));
    }
}
